import React from "react";

const Email: React.FC<{ width?: number; height?: number; color?: string }> = ({
  width = 20,
  height = 20,
  color = "currentColor",
}) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" id="icon" width={width} height={height} viewBox="0 0 32 32">
      <path
        fill={color}
        xmlns="http://www.w3.org/2000/svg"
        d="M28,6H4A2,2,0,0,0,2,8V24a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V8A2,2,0,0,0,28,6ZM25.8,8,16,14.78,6.2,8ZM4,24V8.91l11.43,7.91a1,1,0,0,0,1.14,0L28,8.91V24Z"
        transform="translate(0)"
      />
    </svg>
  );
};

export default Email;
